/* global process */
import React, { useEffect, useMemo, useState } from 'react';
import UpdateNotification from '../components/UpdateNotification/UpdateNotification';
import NavigationProvider from '../context/navigation-context';
import SearchbarProvider from '../context/searchbar-context';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { NotificationContainer } from 'react-notifications';
import { ReportsProvider } from '../context/report-context';

import '../assets/bootstrap.min.css';
import './bootstrap.scss';
import 'react-notifications/lib/notifications.css';
import '../assets/fontawesome/css/all.css';

import './App.css';
import Advertises from '../views/ClientView/Advertises';
import Login from '../views/Auth/login';
import Logout from '../views/Auth/Logout';
import Config from '../views/Config/Config';
import Supply from '../views/Supply/Supply';
import Monitoring from '../views/ConsoleView/Monitoring/Monitoring';
import MonitoringMachine from '../views/ConsoleView/Monitoring/MonitoringMachine';
import ServerStatus from '../views/ConsoleView/ServerStatus/ServerStatus';
import PublicServerStatus from '../views/ConsoleView/ServerStatus/PublicServerStatus';
import VPN from '../views/ConsoleView/VPN/VPN'
import MachinesConsole from '../views/ConsoleView/Machines/Machines';
import FullMachineConsole from '../views/ConsoleView/Machines/FullMachine';
import Terminals from '../views/ConsoleView/Terminals/Terminals';
import Trxs from '../views/ConsoleView/Terminals/Trxs';
import Clients from '../views/ConsoleView/Clients/Clients';

import Categories from '../views/ConsoleView/Categories/Categories';
import Machines from '../views/ClientView/Machines/Machines';
import FullMachine from '../views/ClientView/Machines/FullMachine';
import Tags from '../views/ClientView/Tags/Tags';
import useAuth from '../hooks/auth-hook';
import Codes from '../views/ClientView/Definitions/Codes';
import Personalise from '../views/ClientView/Personalise/Personalise';
import MachineLocations from '../components/Machine/MachineLocations';
import UserView from '../views/Users/UserView';
import Users from '../views/Users/Users';

import Products from '../views/ConsoleView/Products/Products';
import Recipes from '../views/ConsoleView/Products/Recipes';
import Product from '../views/ConsoleView/Products/Product';
import Recipe from '../views/ConsoleView/Products/Recipe';

import Invoices from '../views/ConsoleView/Invoices/Invoices';
import Reports from '../views/ClientView/Reports/Reports';
import Nexgo from '../views/ConsoleView/Nexgo';

import PAS from '../views/ClientView/PAS';
import WIS from '../views/ClientView/WIS';
import AdvancedWIS from '../views/ClientView/AdvancedWIS';
import Start from '../views/ClientView/Start';
import KPS from '../views/ClientView/KPS';
import INMS from '../views/ClientView/INMS';
import DOS from '../views/ClientView/DOS';
import ROS from '../views/ClientView/ROS';
import KOS from '../views/ClientView/KOS';
import INS from '../views/ClientView/INS';
import WZS from '../views/ClientView/WZS';
import PZS from '../views/ClientView/PZS';
import STS from '../views/ClientView/STS';
import ZWS from '../views/ClientView/ZWS';
import FZS from '../views/ClientView/FZS';
import FZ from '../views/ClientView/FZ';
import PA from '../views/ClientView/PA';
import LastVI from '../views/ClientView/LastVI';
import RO from '../views/ClientView/RO';
import ErrorPage from '../views/ClientView/ErrorPage';
import DO from '../views/ClientView/DO';
import MMS from '../views/ClientView/MMS';
import MM from '../views/ClientView/MM';
import Routes from '../views/ClientView/Routes';
import Warehouses from '../views/ClientView/Warehouses';
import Bags from '../views/ClientView/Bags';
import MachineTypes from '../views/ClientView/Definitions/MachineTypes';
import Contractors from '../views/ClientView/Contractors';
import Contractor from '../views/ClientView/Contractor';
import Customer from '../views/ClientView/Customer';
import Events from '../views/ClientView/Events';
import MaintenanceType from '../views/ClientView/MaintenanceType';
import Manufacturers from '../views/ClientView/Manufacturers';
import Deposits from '../views/ClientView/Deposits';
import Notifications from '../views/ClientView/Notifications';
import NotificationsSettings from '../views/ClientView/NotificationsSettings';
import PZ from '../views/ClientView/PZ';
import ZW from '../views/ClientView/ZW';
import ST from '../views/ClientView/ST';
import WZ from '../views/ClientView/WZ';
import IN from '../views/ClientView/IN';
import WHIDoc from '../views/ClientView/WarehouseInventoryRelatedDoc';
import Promotions from '../views/ClientView/Promotions';
import PromotionBasket from '../views/ClientView/PromotionBasket';
import INM from '../views/ClientView/INM';
import KO from '../views/ClientView/KO';
import Prepaids from '../views/ConsoleView/prepaids/Prepaids';
import PrepaidCard from '../views/ConsoleView/prepaids/PrepaidCard';
import PrepaidGroup from '../views/ConsoleView/prepaids/PrepaidGroup';
import CashRegisters from '../views/ClientView/CashRegister/CashRegisters';
import CashRegisterOperation from '../views/ClientView/CashRegister/CashRegisterOperation';
import CashRegister from '../views/ClientView/CashRegister/CashRegister';
import PAUnlogin from '../views/ClientView/CashRegister/PAUnlogin';
import FiscalDocGetting from '../views/ClientView/CashRegister/FiscalDocGetting';
import axios from 'axios';
import CorrectionReason from '../views/ClientView/CorrectionReason';
import Errors from '../views/ClientView/Errors';
import EventsMachine from '../views/Events/Events';
import moment from 'moment';
import IndexedDbContextProvider from '../db/indexedDbProvider';
import schema from '../util/schema.json';
import IndexedDBAsync from '../db/IndexedDBAsync';
import sendPendingVisits from '../views/ClientView/Machines/MachineVI/api/sendPendingVisits';
import MobileLogin from '../views/Auth/MobileLogin';
import checkExaparedInHook from '../util/checkExaparedIn';
import Invoice from '../views/ConsoleView/Invoices/Invoice';
import Loader from '../components/Loader/Loader';
import { API_URL } from '../config/config';

const App = () => {
    axios.defaults.withCredentials = true;

    const location = useLocation();
    const { isAuth, login, logout, setIsAuth } = useAuth();
    const { checkExaparedIn } = checkExaparedInHook();

    const [permission, setPermission] = useState(() => {
        try {
            return JSON.parse(sessionStorage.getItem('permissions') || '[]');
        } catch (err) {
            return [];
        }
    });
    const [customerName, setCustomerName] = useState('');
    const [isAllowed, setIsAllowed] = useState(false);
    const [initDone, setInitDone] = useState(false);

    const isLocalDb = process.env.REACT_APP_LOCAL_DB === 'true';
    const clientId = sessionStorage.getItem('clientId');
    const isConsole = clientId === 'console';
    const isMobile = !!sessionStorage.getItem('isMobile');
    const pathname = location.pathname;

    useEffect(() => {
        checkExaparedIn();
    }, []);

    useEffect(() => {
        if (isLocalDb) return;
        if (!isAuth) return;

        const intervalId = setInterval(() => {
            const currentClientId = sessionStorage.getItem('clientId');
            const expirationDate = localStorage.getItem(`${currentClientId}_expirationDate`);

            if (!currentClientId || !expirationDate) {
                sessionStorage.removeItem('permissions');
                setIsAuth(false);
                return;
            }

            if (new Date(expirationDate) <= new Date()) {
                localStorage.removeItem(`${currentClientId}_token`);
                localStorage.removeItem(`${currentClientId}_expirationDate`);

                if (localStorage.getItem('clientId') === currentClientId) {
                    localStorage.removeItem('clientId');
                }

                sessionStorage.removeItem('clientId');
                sessionStorage.removeItem('permissions');

                setIsAuth(false);
                return;
            }
            checkExaparedIn();
        }, 1000 * 60);

        return () => clearInterval(intervalId);
    }, [isAuth, isLocalDb]);

    useEffect(() => {
        const handleOnline = () => {
            sessionStorage.setItem('isOnline', 'true');

            if (sessionStorage.getItem('synchronization')) return;

            sessionStorage.setItem('synchronization', 'true');

            sendPendingVisits()
                .catch(e => console.error(e))
                .finally(() => sessionStorage.removeItem('synchronization'));
        };

        const handleOffline = () => {
            sessionStorage.setItem('isOnline', 'false');
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    useEffect(() => {
        let isMounted = true;

        const loadInitData = async () => {
            try {
                if (!isAuth) {
                    if (isMounted) {
                        setInitDone(true);
                    }
                    return;
                }

                if (isLocalDb) {
                    if (!navigator.onLine) {
                        const dbAsync = new IndexedDBAsync('dbV1', schema.schemas, 1);
                        await dbAsync.openDB();

                        const cachedPermissions = await dbAsync.getItem('otherInfo', 'permissions');
                        const permissions = (cachedPermissions && cachedPermissions.Data) || [];

                        if (isMounted) {
                            setPermission(permissions);
                            sessionStorage.setItem('permissions', JSON.stringify(permissions));
                            setCustomerName('');
                            setIsAllowed(true);
                            setInitDone(true);
                        }
                        return;
                    }

                    const permissions = await axios
                        .get(`${API_URL}/api/user-permissions`)
                        .then(({ data }) => data || []);

                    if (isMounted) {
                        setPermission(permissions);
                        sessionStorage.setItem('permissions', JSON.stringify(permissions));
                        setCustomerName('');
                        setIsAllowed(true);
                        setInitDone(true);
                    }
                    return;
                }

                if (isConsole) {
                    if (isMounted) {
                        sessionStorage.removeItem('permissions');
                        setPermission([]);
                        setCustomerName('');
                        setIsAllowed(true);
                        setInitDone(true);
                    }
                    return;
                }

                if (isMobile) {
                    if (isMounted) {
                        setCustomerName('');
                        setIsAllowed(true);
                        setInitDone(true);
                    }
                    return;
                }

                if (!navigator.onLine) {
                    const dbAsync = new IndexedDBAsync('dbV1', schema.schemas, 1);
                    await dbAsync.openDB();

                    const [cachedPermissions, cachedCustomerName, cachedConfig] = await Promise.all([
                        dbAsync.getItem('otherInfo', 'permissions'),
                        dbAsync.getItem('otherInfo', 'customerinfo'),
                        dbAsync.getItem('otherInfo', 'customerIsConfigurated')
                    ]);

                    const permissions = (cachedPermissions && cachedPermissions.Data) || [];
                    const customer = (cachedCustomerName && cachedCustomerName.Data) || '';
                    const allowed = (cachedConfig && cachedConfig.Data && cachedConfig.Data.IsConfigurated !== undefined) ? cachedConfig.Data.IsConfigurated : true;

                    if (isMounted) {
                        setPermission(permissions);
                        sessionStorage.setItem('permissions', JSON.stringify(permissions));
                        setCustomerName(customer);
                        setIsAllowed(allowed);
                        setInitDone(true);
                    }
                    return;
                }

                const customer = await axios
                    .get(`${API_URL}/api/customer`)
                    .then(({ data }) => data);

                const allowed = !!(customer && customer.RegulaminZgoda);

                const permissions = await axios
                    .get(`${API_URL}/api/user-permissions`)
                    .then(({ data }) => data || []);

                if (isMounted) {
                    setCustomerName((customer && customer.CustomerName) || '');
                    setIsAllowed(allowed);
                    setPermission(permissions);
                    sessionStorage.setItem('permissions', JSON.stringify(permissions));
                    setInitDone(true);
                }
            } catch (err) {
                if (err.response && err.response.status === 401) {
                    sessionStorage.removeItem('permissions');
                    await logout();
                    window.location.reload();
                    return;
                }

                if (err.response && err.response.data && err.response.data.message === 'jwt malformed') {
                    sessionStorage.removeItem('permissions');
                    window.location.reload();
                    return;
                }

                if (isMounted) {
                    setPermission([]);
                    setCustomerName('');
                    setIsAllowed(false);
                    setInitDone(true);
                }
            }
        };

        loadInitData();

        return () => {
            isMounted = false;
        };
    }, [isAuth, isLocalDb, isConsole, isMobile]);

    const authRoutes = useMemo(() => {
        const routes = [];

        if (isLocalDb) {
            permission.forEach(item => {
                switch (item.Name) {
                    case 'VD_MACHINE_CONFIG':
                        routes.push({ path: '/config', component: Config });
                        break;
                    case 'VD_PRODUCTS':
                        routes.push(
                            { path: '/products', component: Products },
                            { path: '/product/:EAN', component: Product }
                        );
                        break;
                    case 'VD_CATEGORIES':
                        routes.push({ path: '/categories', component: Categories });
                        break;
                    case 'VD_MACHINE_RECHARGE':
                        routes.push({ path: '/supply', component: Supply });
                        break;
                    case 'VD_EVENTS':
                        routes.push({ path: '/events', component: EventsMachine });
                        break;
                    case 'VD_MANUFACTURERS':
                        routes.push({ path: '/manufacturers', component: Manufacturers });
                        break;
                    case 'VD_DEPOSITS':
                        routes.push({ path: '/deposits', component: Deposits });
                        break;
                    case 'VD_USERS':
                        routes.push({ path: '/users', component: Users });
                        break;
                    case 'VD_CUSTOMER':
                        routes.push({ path: '/customer', component: Customer });
                        break;
                    default:
                        break;
                }
            });

            return routes;
        }

        if (isConsole) {
            routes.push(
                { path: '/start', component: Start },
                { path: '/vpn', component: VPN},
                { path: '/server-status', component: ServerStatus },
                { path: '/monitoring', component: Monitoring },
                { path: '/monitoring/:id', component: MonitoringMachine },
                { path: '/machines', component: MachinesConsole },
                { path: '/machine/:machineId', component: FullMachineConsole },
                { path: '/terminals', component: Terminals },
                { path: '/trxs', component: Trxs },
                { path: '/clients', component: Clients },
                { path: '/products', component: Products },
                { path: '/categories', component: Categories },
                { path: '/nexgo', component: Nexgo },
                { path: '/prepaids/:type', component: Prepaids },
                { path: '/prepaids', component: Prepaids },
                { path: '/prepaids/card/:id', component: PrepaidCard },
                { path: '/prepaids/group/:id', component: PrepaidGroup },
                { path: '/customer', component: Customer },
                { path: '/invoices', component: Invoices },
                { path: '/invoices/:id', component: Invoice }
            );

            return routes;
        }

        if (isMobile) {
            routes.push(
                { path: '/machines', component: Machines },
                { path: '/mobile/machines', component: Machines },
                { path: '/machine/:machineId', component: FullMachine },
                { path: '/mobile/machine/:machineId', component: FullMachine }
            );

            return routes;
        }

        routes.push({ path: '/start', component: Start });

        permission.forEach(item => {
            switch (item.Name) {
                case 'VD_MACHINES':
                    routes.push(
                        { path: '/machines', component: Machines },
                        { path: '/machine/:machineId', component: FullMachine }
                    );
                    break;
                case 'VD_WIS':
                    routes.push({ path: '/wis', component: WIS });
                    break;
                case 'VD_ADVANCED_WIS':
                    routes.push({ path: '/advanced-wis', component: AdvancedWIS });
                    break;
                case 'VD_KPS':
                    routes.push({ path: '/kps', component: KPS });
                    break;
                case 'VD_PAS':
                    routes.push(
                        { path: '/pas', component: PAS },
                        { path: '/pa/:id', component: PA }
                    );
                    break;
                case 'VD_DOS':
                    routes.push(
                        { path: '/dos', component: DOS },
                        { path: '/do/:id', component: DO }
                    );
                    break;
                case 'VD_ROS':
                    routes.push(
                        { path: '/ros', component: ROS },
                        { path: '/ro/:id', component: RO }
                    );
                    break;
                case 'VD_INMS':
                    routes.push(
                        { path: '/inms', component: INMS },
                        { path: '/inm/:id', component: INM }
                    );
                    break;
                case 'VD_INS':
                    routes.push(
                        { path: '/ins', component: INS },
                        { path: '/in/:id', component: IN },
                        { path: '/na/:id', component: WHIDoc },
                        { path: '/br/:id', component: WHIDoc }
                    );
                    break;
                case 'VD_WZS':
                    routes.push(
                        { path: '/wzs', component: WZS },
                        { path: '/wz/:id', component: WZ }
                    );
                    break;
                case 'VD_PZS':
                    routes.push(
                        { path: '/pzs', component: PZS },
                        { path: '/pz/:id', component: PZ }
                    );
                    break;
                case 'VD_STS':
                    routes.push(
                        { path: '/sts', component: STS },
                        { path: '/st/:id', component: ST }
                    );
                    break;
                case 'VD_ZWS':
                    routes.push(
                        { path: '/zws', component: ZWS },
                        { path: '/zw/:id', component: ZW }
                    );
                    break;
                case 'VD_FZS':
                    routes.push(
                        { path: '/fzs', component: FZS },
                        { path: '/fz/:warehouseOperationId', component: FZ }
                    );
                    break;
                case 'VD_KOS':
                    routes.push(
                        { path: '/kos', component: KOS },
                        { path: '/ko/:id', component: KO }
                    );
                    break;
                case 'VD_PRODUCTS':
                    routes.push(
                        { path: '/products', component: Products },
                        { path: '/recipes', component: Recipes },
                        { path: '/recipe/:id', component: Recipe },
                        { path: '/product/:EAN', component: Product }
                    );
                    break;
                case 'VD_CATEGORIES':
                    routes.push({ path: '/categories', component: Categories });
                    break;
                case 'VD_TAGS':
                    routes.push({ path: '/tags', component: Tags });
                    break;
                case 'VD_USERS':
                    routes.push(
                        { path: '/users', component: UserView },
                        { path: '/users/:type', component: UserView }
                    );
                    break;
                case 'VD_PAYMENT_CODES':
                    routes.push({ path: '/codes', component: Codes });
                    break;
                case 'VD_PERSONALISE':
                    routes.push(
                        { path: '/personalise', component: Personalise },
                        { path: '/personalise/:type', component: Personalise }
                    );
                    break;
                case 'VD_LOCATIONS':
                    routes.push(
                        { path: '/machinelocations', component: MachineLocations },
                        { path: '/routes', component: Routes }
                    );
                    break;
                case 'VD_TRXS':
                    routes.push({ path: '/trxs', component: Trxs });
                    break;
                case 'VD_MACHINE_TYPES':
                    routes.push({ path: '/machinetypes', component: MachineTypes });
                    break;
                case 'VD_TERMINALS':
                    routes.push({ path: '/terminals', component: Terminals });
                    break;
                case 'VD_LASTVI':
                    routes.push({ path: '/lastvi', component: LastVI });
                    break;
                case 'VD_MM':
                    routes.push(
                        { path: '/mms', component: MMS },
                        { path: '/mm/:id', component: MM }
                    );
                    break;
                case 'VD_WAREHOUSES':
                    routes.push({ path: '/whs', component: Warehouses });
                    break;
                case 'VD_BAGS':
                    routes.push({ path: '/bags', component: Bags });
                    break;
                case 'VD_CONTRACTORS':
                    routes.push(
                        { path: '/contractors', component: Contractors },
                        { path: '/contractor/:id', component: Contractor }
                    );
                    break;
                case 'VD_EVENTS':
                    routes.push({ path: '/events', component: Events });
                    break;
                case 'VD_REPORTS':
                    routes.push({ path: '/reports', component: Reports });
                    break;
                case 'VD_MANUFACTURERS':
                    routes.push({ path: '/manufacturers', component: Manufacturers });
                    break;
                case 'VD_DEPOSITS':
                    routes.push({ path: '/deposits', component: Deposits });
                    break;
                case 'VD_CUSTOMER':
                    routes.push({ path: '/customer', component: Customer });
                    break;
                case 'VD_BASKETS':
                    routes.push(
                        { path: '/promotions/:type', component: Promotions },
                        { path: '/promotions', component: Promotions },
                        { path: '/promotion/basket/:id', component: PromotionBasket }
                    );
                    break;
                case 'VD_PREPAID':
                    routes.push(
                        { path: '/prepaids/:type', component: Prepaids },
                        { path: '/prepaids', component: Prepaids },
                        { path: '/prepaids/card/:id', component: PrepaidCard },
                        { path: '/prepaids/group/:id', component: PrepaidGroup }
                    );
                    break;
                case 'VD_MONITORING':
                    routes.push(
                        { path: '/monitoring', component: Monitoring },
                        { path: '/monitoring/:id', component: MonitoringMachine }
                    );
                    break;
                case 'VD_WKF':
                    routes.push(
                        { path: '/wkfs', component: CashRegisters },
                        { path: '/wkfs/:type', component: CashRegisters },
                        { path: '/wkf/cashRegister/:id', component: CashRegister },
                        { path: '/wkf/:type/:id', component: CashRegisterOperation },
                        { path: '/wkf/:params', component: FiscalDocGetting }
                    );
                    break;
                case 'VD_CR':
                    routes.push({ path: '/corection-reasons', component: CorrectionReason });
                    break;
                case 'VD_ERRORS':
                    routes.push({ path: '/errors', component: Errors });
                    break;
                case 'VD_MAINTENANCE_TYPE':
                    routes.push({ path: '/maintenance-type', component: MaintenanceType });
                    break;
                case 'VD_NOTIFICATIONS':
                    routes.push({ path: '/notifications', component: Notifications },
                        { path: '/notifications-settings', component: NotificationsSettings }
                    );
                    break;
                case 'VD_ADVERTISES':
                    routes.push({ path: '/advertises', component: Advertises });
                    break;
                default:
                    break;
            }
        });

        return routes;
    }, [isLocalDb, isConsole, isMobile, permission]);

    const getInitialRedirectPath = () => {
        if (authRoutes.length === 0) return null;
        return (authRoutes[0] && authRoutes[0].path) || null;
    };

    const renderLoginRoutes = () => {
        if (pathname.includes('wkf/')) {
            return <Route exact path="/wkf/:params" render={() => <PAUnlogin />} />;
        }

        if (pathname.includes('/mobile') || isMobile) {
            return (
                <>
                    <Route
                        exact
                        path="/mobile/login"
                        render={() => <MobileLogin login={login} setPermission={setPermission} />}
                    />
                    <Redirect to="/mobile/login" />
                </>
            );
        }

        return (
            <>
                <Route
                    exact
                    path="/login"
                    render={() => <Login login={login} setPermission={setPermission} />}
                />
                <Redirect to="/login" />
            </>
        );
    };

    if (!initDone) {
        return (
            <div className="d-flex min-vh-100 bg-light justify-content-center align-items-center">
                <Loader/>
            </div>
        );
    }

    return (
        <div className="d-flex min-vh-100 bg-light">
            <Switch>
                <Route exact path="/public-status" component={PublicServerStatus} />
                <Route path="*">
                    {isAuth ? (
                        <IndexedDbContextProvider>
                            <ReportsProvider>
                                <NavigationProvider
                                    permissions={permission}
                                    customerName={customerName}
                                    isAllowed={isAllowed}
                                    isConsole={isConsole}
                                    isLocalDb={isLocalDb}
                                    isMobile={isMobile}
                                >
                                    <SearchbarProvider>
                                        {authRoutes.length > 0 ? (
                                            <Switch>
                                                {authRoutes.map((route, idx) => (
                                                    <Route key={idx} exact {...route} />
                                                ))}

                                                <Route
                                                    exact
                                                    path="/logout"
                                                    render={() => <Logout logout={logout} />}
                                                />

                                                {!isLocalDb &&
                                                    (() => {
                                                        switch (window.location.pathname) {
                                                            case '/dashboard/mobile/login':
                                                                return <Redirect to="/mobile/machines" />;
                                                            case '/dashboard/login':
                                                                sessionStorage.removeItem('isMobile');
                                                                return <Redirect to="/start" />;
                                                            default:
                                                                return null;
                                                        }
                                                    })()}

                                                {isLocalDb ? (
                                                    <Redirect to="/products" />
                                                ) : null}

                                                <Route exact path="/">
                                                    {isMobile ? <Machines /> : <Start />}
                                                </Route>

                                                <Route exact path="*">
                                                    <ErrorPage />
                                                </Route>

                                                <Route path="*">
                                                    <ErrorPage />
                                                </Route>

                                                {getInitialRedirectPath() ? (
                                                    <Redirect to={getInitialRedirectPath()} />
                                                ) : null}
                                            </Switch>
                                        ) : null}
                                    </SearchbarProvider>
                                </NavigationProvider>
                            </ReportsProvider>
                        </IndexedDbContextProvider>
                    ) : (
                        <Switch>{renderLoginRoutes()}</Switch>
                    )}
                </Route>
            </Switch>

            <NotificationContainer />
            <UpdateNotification />
        </div>
    );
};

export default App;